import { styled } from "styled-components";
import { useModal } from "@ludens-reklame/react-modal";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { Button } from "../../internal-components/Button.js";
import { CartItem } from "@ludens-reklame/rubics-v3-sdk/cart/types";

const ModalWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.l};
  max-height: 100vh;
  overflow-y: auto;

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => `${props.theme.spacing.xl} ${props.theme.spacing.l}`};
    width: 1100px;
  }
`;

const ModalContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.s};
  background-color: #fff;

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
  }
`;

const ModalProductImage = styled.div`
  display: flex;
  border: 1px solid var(--swatch5);
  width: 142px;
  height: 142px;

  img {
    width: 142px;
    height: 142px;
  }
`;

const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing.s};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    align-items: flex-end;
    gap: ${(props) => props.theme.spacing.m};
  }
`;

const ModalProductInfoWrapper = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.xs};

  h1,
  p {
    margin: 0;
  }

  h1 {
    margin-bottom: ${(props) => props.theme.spacing.xs};
  }

  p:last-child {
    margin-top: ${(props) => props.theme.spacing.xs};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    gap: ${(props) => props.theme.spacing.m};

    p:last-child {
      margin-top: ${(props) => props.theme.spacing.m};
    }
  }
`;

export const AddToCartModal: React.FC<{ item: CartItem }> = ({ item }) => {
  const { despawnModal } = useModal();
  const { product, totalText } = item;

  return (
    <ModalWrapper title="Produktet ble lagt til i handlekurven">
      <ModalContentWrapper>
        <ModalProductInfoWrapper>
          {product.primaryImage && (
            <ModalProductImage>
              <img
                src={transformImageUrl(product.primaryImage, {
                  width: 284,
                  height: 284,
                  fit: "contain",
                })}
                alt={product.primaryImage.altText}
              />
            </ModalProductImage>
          )}
          <div>
            <h1 className="b3">{product.name}</h1>
            {product.attributes.length > 0
              ? product.attributes.map((attr) => (
                  <p key={attr._id}>
                    {attr.name}: {attr.value}
                  </p>
                ))
              : null}
            <p>{totalText}</p>
          </div>
        </ModalProductInfoWrapper>
        <ModalButtonWrapper>
          <Button $variant="secondary" onClick={despawnModal}>
            Fortsett å handle
          </Button>
          <Button as="a" $variant="primary" href="/utsjekk">
            Til kassa
          </Button>
        </ModalButtonWrapper>
      </ModalContentWrapper>
    </ModalWrapper>
  );
};
